{
  "nl": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Ontvang een notificatie wanneer een nieuw nieuwsbericht wordt geplaatst.",
          "label": "Nieuws"
        },
        "question": {
          "description": "Ontvang een notificatie wanneer een nieuwe vraag wordt aangemaakt.",
          "label": "FAQ"
        }
      },
      "employees": {
        "announcement": {
          "description": "Ontvang een notificatie wanneer een nieuw nieuwsbericht wordt geplaatst.",
          "label": "Nieuws"
        },
        "decision": {
          "description": "Ontvang alle notificaties in verband met beslissingen.",
          "label": "Beslissingen"
        },
        "document": {
          "description": "Ontvang een notificatie wanneer een nieuw document wordt geüpload.",
          "employee_create": {
            "description": "Ontvang een notificatie wanneer documenten worden geüpload door andere medewerkers.",
            "label": "Documenten door collega's"
          },
          "label": "Documenten"
        },
        "export": {
          "description": "Ontvang een notificatie wanneer een export gegenereerd is.",
          "label": "Exports"
        },
        "question": {
          "description": "Ontvang een notificatie wanneer een nieuwe vraag wordt aangemaakt.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Ontvang alle notificaties in verband met enquêtes.",
          "label": "Enquêtes"
        },
        "ticket": {
          "description": "Ontvang alle notificaties in verband met gesprekken.",
          "label": "Gesprekken"
        },
        "todo": {
          "description": "Ontvang een notificatie wanneer een taak aan jou wordt toegewezen.",
          "label": "Taken toewijzingen"
        }
      },
      "labels": {
        "email_preferences": "E-mailvoorkeuren",
        "general_preferences": "Mijn Notificatievoorkeuren",
        "receiveEmailNotificationsAbout": "Ontvang e-mailnotificaties"
      }
    }
  }
}
